import {
  generateAsyncActionCreators,
} from '../core/reduxUtils';

const getAppExperimentsActionCreators = generateAsyncActionCreators(
  'GET_APP_EXPERIMENTS',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getSearchExperimentsActionCreators = generateAsyncActionCreators(
  'GET_SEARCH_EXPERIMENTS',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getDesktopSearchExperimentsActionCreators = generateAsyncActionCreators(
  'GET_DESKTOP_SEARCH_EXPERIMENTS',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const actionCreators = {
  getAppExperiments: {
    ...getAppExperimentsActionCreators,
  },
  getSearchExperiments:{
    ...getSearchExperimentsActionCreators,
  },
  getDesktopSearchExperiments:{
    ...getDesktopSearchExperimentsActionCreators,
  }
};


export {
  actionCreators,
  getAppExperimentsActionCreators,
  getSearchExperimentsActionCreators,
  getDesktopSearchExperimentsActionCreators,
};
